export function extractCurrentPath(component): string {
  return component.props.router.getCurrentLocation().pathname;
}


// WEBPACK FOOTER //
// ./source/js/utils/routes.ts